const getCountry = (word) => {
    const href = window.location.href
    if(href.includes('com.br') || href.includes('sparlack/br')) {
        return "Br"
    } else if (href.includes('com.bo') || href.includes('sparlack/bol') ) {
        return "Bol"
    }else { 
        return "Chi"
    }
} 
export default getCountry